import { createContext, useState } from 'react';
const emptyObj: { [index: string]: any } = {}
const VideoContext = createContext({
    isAdmin: false,
    isVideoFullscreen: false,
    isYoutube: false,
    userId: '',
    userRole: '',
    transId: '',
    tagData: {instruments: [], steps:[], anatomy:[]},
  //tagData: emptyObj, 
  userData: emptyObj,
    videoTime: 0,
    currentVideoTime: 0,
    tagPosition: {x:0, y:0},
    accordionData: [],
    detailsRef: emptyObj,
    equipmentList : [],
    isReply: false,
    replyMsg: emptyObj,
    enquiryProduct: emptyObj,
    viewCount: 0,
    videoData: emptyObj,
    instrumentEnquiry: emptyObj,
    isInstrumentEnquiry:false,
    rating: 0,
    accordionClickedItem: emptyObj,
    isLoaderActive:true,
    setUserIdValue:(id:any)=>{},
    setUserRoleHandler:(role:any)=>{},
    setIsAdminHandler:(value:any)=>{},
    setTransIdValue:(id:any)=>{},
    setTagDataHandler: (data: any)=>{},
    setUserDataHandler: (user: any)=>{},
    setVideoTimeHandler: (time: any)=>{},
    setCurrentVideoTimeHandler: (currentTime: any)=>{},
    setTagPositionHandler: (postion: any)=>{},
    setAccordionDataHandler: (item:any)=>{},
    pushAccordionDataHandler: (accordionItem:any)=>{},
    deleteAccordionDataHandler: (deleteItemID:any)=>{},
    setFullScreenHandler: (alert: any)=>{},
    setIsYoutubeHandler: (value: any)=>{},
    detailsRefHandler: (value: any)=>{},
    setEquipmentListDataHandler: (value: any)=>{},
    setIsReplyHandler:(value:any)=>{},
    setReplyMsgHandler:(user: any)=>{},
    setEnquiryProductHandler:(product: any)=>{},
    setViewCountHandler:(count: any)=>{},
    setVideoDataHandler:(data:any)=>{},
    setInstrumentEnquiryHandler:(data:any)=>{},
    setIsInstrumentEnquiryHandler:(flag:any)=>{},
    setRatingHandler:(rate:any)=>{},
    setAccordionClickedItemHandler: (item: any)=>{},
    setIsLoaderActiveHandler: (flag: any)=>{},
});

export function VideoContextProvider(props: any) {
   const [isAdmin,setIsAdmin]= useState(false);
   const [isInstrumentEnquiry,setIsInstrumentEnquiry]= useState(false);
   const [userId,setUserId]= useState('');
   const [userRole, setUserRole]=useState('');
   const [transId,setTransId]= useState('');
   const [tagData, setTagData]=useState({instruments: [], steps:[], anatomy:[]});
  // const [tagData, setTagData]=useState(emptyObj);
   const [userData, setUserData] = useState(emptyObj);
   const [videoTime, setVideoTime] = useState(0);
   const [currentVideoTime, setCurrentVideoTime] = useState(0);
   const [tagPosition, setTagPostion] = useState({x:0,y:0});
   const [accordionData, setAccordionData] = useState([] as any);
   const [isVideoFullscreen, setIsVideoFullscreen] = useState(false);
   const [isYoutube, setIsYoutube] = useState(false);
   const [detailsRef, setDetailsRef] = useState(emptyObj);
   const [equipmentList, setEquipmentList] = useState([]);
   const [isReply,setIsReply]= useState(false);
   const [replyMsg, setReplyMsg] = useState(emptyObj);
   const [enquiryProduct, setEnquiryProduct] = useState(emptyObj);
   const [viewCount, setViewCount] = useState(0);
   const [videoData, setVideoData] = useState(emptyObj);
   const [instrumentEnquiry, setInstrumentEnquiry] = useState(emptyObj);
   const [rating, setRating] = useState(0)
   const [accordionClickedItem, setAccordionClickedItem] = useState(emptyObj);
   const [isLoaderActive,setIsLoaderActive]= useState(true);
   
   function setUserHandler(id:any){
       setUserId((preId:any)=>{
           return id;
       })
   }
   function setUserRoleHandler(role:any){
       setUserRole((preRole:any)=>{
           return role;
       })
   }
   function setTransHandler(id:any){
       setTransId((preId: any)=>{
           return id;
       })
   }
   function setIsAdminHandler(value:any){
       setIsAdmin((preVal: any)=>{
           return value;
       })
   }
   function setTagDataHandler(data:any){
        setTagData(()=>{
            return data;
        })
   }
   function setUserDataHandler(user:any){
       setUserData(()=>{
           return user;
       })
   }
   function setVideoTimeHandler(time:any){
        setVideoTime(()=>{
           return time;
       })
   }
   function setCurrentVideoTimeHandler(currentTime:any){
        setCurrentVideoTime(()=>{
           return currentTime;
       })
   }
   function setTagPositionHandler(postion:any){
        setTagPostion(()=>{
           return postion;
       })
   }
   function setAccordionDataHandler(accordion:any){
    setAccordionData((preData:any)=>{
       return accordion;
     })
    }
   function pushAccordionDataHandler(accordionItem:any){
    setAccordionData((preData:any)=>{
    return [...preData, accordionItem].sort((a:any,b:any)=>{
        return a.time - b.time
    })
     })
    }
    function deleteAccordionDataHandler(deleteItemID:any){
        setAccordionData((preData:any)=>{
            // console.log('delete accordtion predata', preData);
            return preData.filter((d:any)=> d.id !== deleteItemID)
         })
        }
   function setFullScreenHandler(status:any){
        setIsVideoFullscreen((prestatus: any)=>{
           return status;
       })
   }
   function setIsYoutubeHandler(value:any){
        setIsYoutube((preValue: any)=>{
           return value;
       })
   }
   function detailsRefHandler(value:any){
        setDetailsRef((preValue: any)=>{
           return value;
       })
   }
   function setEquipmentListDataHandler(data:any){
    setEquipmentList(()=>{
        return data;
    })  
}
function setIsReplyHandler(value:any){
    setIsReply((preVal: any)=>{
        return value;
    })
}
function setReplyMsgHandler(user:any){
    setReplyMsg(()=>{
        return user;
    })
}
function setEnquiryProductHandler(product:any){
    setEnquiryProduct(()=>{
        return product;
    })
}
function setViewCountHandler(count:any){
    setViewCount(()=>{
        return count;
    })
}
function setVideoDataHandler(data:any){
    setVideoData(()=>{
        return data;
    })
}
function setInstrumentEnquiryHandler(data:any){
    setInstrumentEnquiry(()=>{
        return data;
    })
}
function setIsInstrumentEnquiryHandler(value:any){
    setIsInstrumentEnquiry((preVal: any)=>{
        return value;
    })
}
function setRatingHandler(rate:any){
    setRating(()=>{
        return rate;
    })
}
function setAccordionClickedItemHandler(data:any){
    setAccordionClickedItem(()=>{
        return data;
    })
}
function setIsLoaderActiveHandler(data:any){
    setIsLoaderActive(()=>{
        return data;
    })
}
const context = {
       isAdmin: isAdmin,
       userId: userId,
       userRole: userRole,
       transId: transId,
       tagData: tagData,
       userData: userData,
       videoTime: videoTime,
       currentVideoTime: currentVideoTime,
       tagPosition: tagPosition,
       accordionData: accordionData,
       isVideoFullscreen: isVideoFullscreen,
       isYoutube:isYoutube,
       detailsRef:detailsRef,
       equipmentList : equipmentList,
       isReply: isReply,
       replyMsg: replyMsg,
       enquiryProduct:enquiryProduct,
       viewCount: viewCount,
       videoData: videoData,
       isInstrumentEnquiry:isInstrumentEnquiry,
       instrumentEnquiry: instrumentEnquiry,
       rating: rating,
       accordionClickedItem: accordionClickedItem,
       isLoaderActive: isLoaderActive,
       setUserIdValue: setUserHandler,
       setUserRoleHandler: setUserRoleHandler,
       setTransIdValue: setTransHandler,
       setIsAdminHandler:setIsAdminHandler,
       setTagDataHandler: setTagDataHandler,
       setUserDataHandler: setUserDataHandler,
       setVideoTimeHandler: setVideoTimeHandler,
       setCurrentVideoTimeHandler: setCurrentVideoTimeHandler,
       setTagPositionHandler: setTagPositionHandler,
       setAccordionDataHandler: setAccordionDataHandler,
       pushAccordionDataHandler: pushAccordionDataHandler,
       deleteAccordionDataHandler: deleteAccordionDataHandler,
       setFullScreenHandler: setFullScreenHandler,
       setIsYoutubeHandler: setIsYoutubeHandler,
       detailsRefHandler: detailsRefHandler,
       setEquipmentListDataHandler:setEquipmentListDataHandler,
       setIsReplyHandler: setIsReplyHandler,
       setReplyMsgHandler:setReplyMsgHandler,
       setEnquiryProductHandler: setEnquiryProductHandler,
       setViewCountHandler:setViewCountHandler,
       setVideoDataHandler: setVideoDataHandler,
       setInstrumentEnquiryHandler: setInstrumentEnquiryHandler,
       setIsInstrumentEnquiryHandler:setIsInstrumentEnquiryHandler,
       setRatingHandler:setRatingHandler,
       setAccordionClickedItemHandler:setAccordionClickedItemHandler,
       setIsLoaderActiveHandler:setIsLoaderActiveHandler,
   }
   return (<VideoContext.Provider value={context}>
        {props.children}
    </VideoContext.Provider>)
}
export default VideoContext;